export default "__VITE_ASSET__D0juGQ8F__"